import Vue from "vue";
import Router from "vue-router";
import { Url } from "@/commons/constants/Url";
import { PcUrl } from "@/commons/constants/PcUrl";
import { MobileUrl } from "@/commons/constants/MobileUrl";

// common components
import Login from "@/commons/pages/Login.vue";
import Maintenance from "@/commons/pages/Maintenance.vue";
import SystemError from "@/commons/pages/SystemError.vue";
import UnsupportedAgent from "@/commons/pages/UnsupportedAgent.vue";
import NotFound from "@/commons/pages/NotFound.vue";
import NetworkError from "@/commons/pages/NetworkError.vue";

// pc components
import BaseLayout from "@/pc/pages/Base.vue";
import HomeForFamiliesService from "@/pc/pages/HomeForFamiliesService.vue";
import Report from "@/pc/pages/reports/Report.vue";
import Facility from "@/pc/pages/settings/Facility.vue";
import FacilityEdit from "@/pc/pages/settings/FacilityEdit.vue";
import ResidentList from "@/pc/pages/residents/ResidentList.vue";
import ResidentRegister from "@/pc/pages/residents/ResidentRegister.vue";
import ResidentMultipleRegister from "@/pc/pages/residents/ResidentMultipleRegister.vue";
import GetResidentsForCooperationSystem from "@/pc/pages/residents/GetResidentsForCooperationSystem.vue";
import ResidentDetail from "@/pc/pages/residents/ResidentDetail.vue";
import ResidentEdit from "@/pc/pages/residents/ResidentEdit.vue";
import ResidentGroupList from "@/pc/pages/residents/ResidentGroupList.vue";
import ResidentGroupRegister from "@/pc/pages/residents/ResidentGroupRegister.vue";
import ResidentGroupEdit from "@/pc/pages/residents/ResidentGroupEdit.vue";
import ResidentGroupMemberEdit from "@/pc/pages/residents/ResidentGroupMemberEdit.vue";
import CareimageList from "@/pc/pages/careimages/CareimageList.vue";
import CareimageRegister from "@/pc/pages/careimages/CareimageRegister.vue";
import CareimageMultipleRegister from "@/pc/pages/careimages/CareimageMultipleRegister.vue";
import FamilyList from "@/pc/pages/families/FamilyList.vue";
import FamilyRegister from "@/pc/pages/families/FamilyRegister.vue";
import FamilyEdit from "@/pc/pages/families/FamilyEdit.vue";
import ReservationList from "@/pc/pages/reservations/ReservationList.vue";
import ReservationSettings from "@/pc/pages/reservations/ReservationSettings.vue";
import ReservationSchedules from "@/pc/pages/reservations/ReservationSchedules.vue";
import ReservationScheduleTemplateEdit from "@/pc/pages/reservations/ReservationScheduleTemplateEdit.vue";
import ReservationScheduleTemplateList from "@/pc/pages/reservations/ReservationScheduleTemplateList.vue";
import ReservationScheduleTemplateRegister from "@/pc/pages/reservations/ReservationScheduleTemplateRegister.vue";
import OutingList from "@/pc/pages/outings/OutingList.vue";
import OutingDetail from "@/pc/pages/outings/OutingDetail.vue";
import OutingRegister from "@/pc/pages/outings/OutingRegister.vue";
import OutingEdit from "@/pc/pages/outings/OutingEdit.vue";
import OutingSetting from "@/pc/pages/outings/OutingSetting.vue";
import EventList from "@/pc/pages/events/EventList.vue";
import EventRegister from "@/pc/pages/events/EventRegister.vue";
import EventEdit from "@/pc/pages/events/EventEdit.vue";
import EventReplyRegister from "@/pc/pages/events/EventReplyRegister.vue";
import EventReplyEdit from "@/pc/pages/events/EventReplyEdit.vue";
import OtherUserGroupList from "@/pc/pages/otherUserGroups/OtherUserGroupList.vue";
import OtherUserGroupRegister from "@/pc/pages/otherUserGroups/OtherUserGroupRegister.vue";
import OtherUserGroupEdit from "@/pc/pages/otherUserGroups/OtherUserGroupEdit.vue";
import OtherUserGroupTypeList from "@/pc/pages/otherUserGroups/OtherUserGroupTypeList.vue";
import OtherUserGroupTypeEdit from "@/pc/pages/otherUserGroups/OtherUserGroupTypeEdit.vue";
import OtherUserGroupMemberRegister from "@/pc/pages/otherUserGroups/OtherUserGroupMemberRegister.vue";
import OtherUserGroupMemberEdit from "@/pc/pages/otherUserGroups/OtherUserGroupMemberEdit.vue";
import PictureList from "@/pc/pages/pictures/PictureList.vue";
import FamilyMessageList from "@/pc/pages/familyMessages/MessageList.vue";
import SafetyConfirmList from "@/pc/pages/safetyConfirm/SafetyConfirmList.vue";
import SafetyConfirmRegister from "@/pc/pages/safetyConfirm/SafetyConfirmRegister.vue";
import SendOtherUserSafetyConfirm from "@/pc/pages/safetyConfirm/SendOtherUserSafetyConfirm.vue";
import FamilyTemplateEdit from "@/pc/pages/safetyConfirm/FamilyTemplateEdit.vue";
import FamilySafetyConfirmDetail from "@/pc/pages/safetyConfirm/FamilySafetyConfirmDetail.vue";
import OtherUserSafetyConfirmAnswers from "@/pc/pages/safetyConfirm/OtherUserSafetyConfirmAnswers.vue";
import OtherUserSafetyConfirmDetail from "@/pc/pages/safetyConfirm/OtherUserSafetyConfirmDetail.vue";
import OtherUserTemplateEdit from "@/pc/pages/safetyConfirm/OtherUserTemplateEdit.vue";
import SendMessage from "@/pc/pages/sendMessages/SendMessage.vue";
import SendMessageGroupList from "@/pc/pages/sendMessageGroups/SendMessageGroupList.vue";
import SendMessageGroupRegister from "@/pc/pages/sendMessageGroups/SendMessageGroupRegister.vue";
import SendMessageGroupEdit from "@/pc/pages/sendMessageGroups/SendMessageGroupEdit.vue";
import SendMessageGroupMemberEdit from "@/pc/pages/sendMessageGroups/SendMessageGroupMemberEdit.vue";
import SendMessageSettingEdit from "@/pc/pages/sendMessages/SendMessageSettingEdit.vue";
import SendMessageTemplateList from "@/pc/pages/sendMessages/SendMessageTemplateList.vue";
import SendMessageTemplateRegister from "@/pc/pages/sendMessages/SendMessageTemplateRegister.vue";
import SendMessageTemplateEdit from "@/pc/pages/sendMessages/SendMessageTemplateEdit.vue";
import SendDocumentList from "@/pc/pages/sendDocuments/SendDocumentList.vue";
import SendDocumentRegister from "@/pc/pages/sendDocuments/SendDocumentRegister.vue";
import SendDocumentEdit from "@/pc/pages/sendDocuments/SendDocumentEdit.vue";
import SendDocumentDetail from "@/pc/pages/sendDocuments/SendDocumentDetail.vue";
import SendDocumentCategoryList from "@/pc/pages/sendDocuments/CategoryList.vue";
import SendDocumentCategoryEdit from "@/pc/pages/sendDocuments/CategoryEdit.vue";
import SendDocumentTemplateList from "@/pc/pages/sendDocuments/SendDocumentTemplateList.vue";
import SendDocumentTemplateRegister from "@/pc/pages/sendDocuments/SendDocumentTemplateRegister.vue";
import SendDocumentTemplateEdit from "@/pc/pages/sendDocuments/SendDocumentTemplateEdit.vue";
import StandardAccountList from "@/pc/pages/settings/StandardAccountList.vue";
import StandardAccountRegister from "@/pc/pages/settings/StandardAccountRegister.vue";
import StandardAccountEdit from "@/pc/pages/settings/StandardAccountEdit.vue";
import ReceiveMessageList from "@/pc/pages/receiveMessages/ReceiveMessageList.vue";
import ReceiveMessageSetting from "@/pc/pages/receiveMessages/ReceiveMessageSetting.vue";
import FaqList from "@/pc/pages/supports/FaqList.vue";
import SupportList from "@/pc/pages/supports/SupportList.vue";
import SupportRegister from "@/pc/pages/supports/SupportRegister.vue";
import ManualList from "@/pc/pages/supports/ManualList.vue";
import NotificationList from "@/pc/pages/notifications/NotificationList.vue";
import NotificationDetail from "@/pc/pages/notifications/NotificationDetail.vue";
import AccountEdit from "@/pc/pages/users/AccountEdit.vue";
import About from "@/pc/pages/users/About.vue";
import NotificationSettingEdit from "@/pc/pages/settings/NotificationSettingEdit.vue";
import Plan from "@/pc/pages/settings/Plan.vue";
import PermittedFunctionList from "@/pc/pages/settings/PermittedFunctionList.vue";
import PermittedFunctionEdit from "@/pc/pages/settings/PermittedFunctionEdit.vue";
import FamilyPermittedFunctionList from "@/pc/pages/settings/FamilyPermittedFunctionList.vue";
import DefaultFamilyPermittedFunctionEdit from "@/pc/pages/settings/DefaultFamilyPermittedFunctionEdit.vue";
import OtherUserPermittedFunctionList from "@/pc/pages/settings/OtherUserPermittedFunctionList.vue";
import OtherUserPermittedFunctionEdit from "@/pc/pages/settings/OtherUserPermittedFunctionEdit.vue";
import Terminate from "@/pc/pages/settings/Terminate.vue";
import RoomList from "@/pc/pages/settings/RoomList.vue";
import RoomRegister from "@/pc/pages/settings/RoomRegister.vue";
import RoomEdit from "@/pc/pages/settings/RoomEdit.vue";
import RoomMultipleRegister from "@/pc/pages/settings/RoomMultipleRegister.vue";
import RoomScheduleList from "@/pc/pages/roomSchedules/RoomScheduleList.vue";
import RoomScheduleSetting from "@/pc/pages/roomSchedules/RoomScheduleSetting.vue";
import QuestionnaireList from "@/pc/pages/questionnaires/QuestionnaireList.vue";
import QuestionnaireRegister from "@/pc/pages/questionnaires/QuestionnaireRegister.vue";
import QuestionnaireEdit from "@/pc/pages/questionnaires/QuestionnaireEdit.vue";
import QuestionnaireDetail from "@/pc/pages/questionnaires/QuestionnaireDetail.vue";
import CooperationSystemList from "@/pc/pages/settings/CooperationSystemList.vue";

import HomeForWaitersService from "@/pc/pages/HomeForWaitersService.vue";
import WaiterList from "@/pc/pages/waiters/WaiterList.vue";
import WaiterListDownload from "@/pc/pages/waiters/WaiterListDownload.vue";
import WaiterSetting from "@/pc/pages/waiters/WaiterSetting.vue";
import WaiterRegister from "@/pc/pages/waiters/WaiterRegister.vue";
import WaiterDetail from "@/pc/pages/waiters/WaiterDetail.vue";
import WaiterChangeRequest from "@/pc/pages/waiters/WaiterChangeRequest.vue";
import WaiterEdit from "@/pc/pages/waiters/WaiterEdit.vue";
import WaiterProgressHistoryRegister from "@/pc/pages/waiters/WaiterProgressHistoryRegister.vue";
import WaiterProgressHistoryEdit from "@/pc/pages/waiters/WaiterProgressHistoryEdit.vue";
import WaiterFamilyRegister from "@/pc/pages/waiters/WaiterFamilyRegister.vue";
import WaiterFamilyEdit from "@/pc/pages/waiters/WaiterFamilyEdit.vue";
import WaiterReceiveMessageList from "@/pc/pages/waiterReceiveMessages/ReceiveMessageList.vue";
import WaiterReceiveMessageSetting from "@/pc/pages/waiterReceiveMessages/ReceiveMessageSetting.vue";
import FollowerList from "@/pc/pages/followers/FollowerList.vue";
import InspectionReservationList from "@/pc/pages/inspectionReservations/InspectionReservationList.vue";
import InspectionReservationRegister from "@/pc/pages/inspectionReservations/InspectionReservationRegister.vue";
import InspectionReservationEdit from "@/pc/pages/inspectionReservations/InspectionReservationEdit.vue";
import RecruitmentContactList from "@/pc/pages/recruitmentContacts/RecruitmentContactList.vue";
import RecruitmentContactRegister from "@/pc/pages/recruitmentContacts/RecruitmentContactRegister.vue";
import RecruitmentContactEdit from "@/pc/pages/recruitmentContacts/RecruitmentContactEdit.vue";
import WaiterSendMessage from "@/pc/pages/sendWaiterMessages/SendMessage.vue";
import WaiterSettingEdit from "@/pc/pages/sendWaiterMessages/SettingEdit.vue";
import WaiterTemplateEdit from "@/pc/pages/sendWaiterMessages/TemplateEdit.vue";
import WaiterTemplateList from "@/pc/pages/sendWaiterMessages/TemplateList.vue";
import WaiterTemplateRegister from "@/pc/pages/sendWaiterMessages/TemplateRegister.vue";

import HomeForOtherOfficeService from "@/pc/pages/HomeForOtherOfficeService.vue";
import OtherOfficeConnectionEdit from "@/pc/pages/base/OtherOfficeConnectionEdit.vue";
import OtherOfficeSendMessage from "@/pc/pages/sendOtherOfficeMessages/OtherOfficeMessages.vue";
import OtherOfficeOnlineMeetings from "@/pc/pages/otherOfficeOnlineMeetings/OnlineMeetings.vue";
import OtherOfficeOnlineMeetingRegister from "@/pc/pages/otherOfficeOnlineMeetings/OnlineMeetingRegister.vue";
import OtherOfficeOnlineMeetingDetail from "@/pc/pages/otherOfficeOnlineMeetings/OnlineMeetingDetail.vue";
import OtherOfficeOnlineMeetingEdit from "@/pc/pages/otherOfficeOnlineMeetings/OnlineMeetingEdit.vue";
import OtherOfficeRoomsScheduleList from "@/pc/pages/otherOfficeRoomSchedules/RoomScheduleList.vue";

// mobile components
import MobileBase from "@/mobile/pages/Base.vue";
import MobileHome from "@/mobile/pages/Home.vue";
import MobileReservationList from "@/mobile/pages/reservations/ReservationList.vue";
import MobileReservationDetail from "@/mobile/pages/reservations/ReservationDetail.vue";
import MobileOutingList from "@/mobile/pages/outings/OutingList.vue";
import MobileOutingDetail from "@/mobile/pages/outings/OutingDetail.vue";
import MobileOutingEdit from "@/mobile/pages/outings/OutingEdit.vue";
import MobileMessageRegisterInput from "@/mobile/pages/sendMessages/MessageRegisterInput.vue";
import MobileMessageRegisterConfirm from "@/mobile/pages/sendMessages/MessageRegisterConfirm.vue";
import MobileMessageRegisterComplete from "@/mobile/pages/sendMessages/MessageRegisterComplete.vue";
import MobileNewArrivalMessagesList from "@/mobile/pages/NewArrivalMessagesList.vue";
import MobileFamilyMessageList from "@/mobile/pages/sendMessages/FamilyMessageList.vue";
import MobileFamilyMessageHistoryDetail from "@/mobile/pages/sendMessages/FamilyMessageHistoryDetail.vue";
import MobileFamilyMessageReplyDetail from "@/mobile/pages/sendMessages/FamilyMessageReplyDetail.vue";
import MobileOtherUserMessageList from "@/mobile/pages/sendMessages/OtherUserMessageList.vue";
import MobileOtherUserMessageHistoryDetail from "@/mobile/pages/sendMessages/OtherUserMessageHistoryDetail.vue";
import MobileOtherUserMessageReplyDetail from "@/mobile/pages/sendMessages/OtherUserMessageReplyDetail.vue";
import MobileFamilyReceiveMessageList from "@/mobile/pages/receiveMessages/FamilyReceiveMessageList.vue";
import MobileFamilyReceiveMessageDetail from "@/mobile/pages/receiveMessages/FamilyReceiveMessageDetail.vue";
import MobileFamilyReplyMessageConfirm from "@/mobile/pages/receiveMessages/FamilyReplyMessageConfirm.vue";
import MobileOtherUserReceiveMessageList from "@/mobile/pages/receiveMessages/OtherUserReceiveMessageList.vue";
import MobileOtherUserReceiveMessageDetail from "@/mobile/pages/receiveMessages/OtherUserReceiveMessageDetail.vue";
import MobileOtherUserReplyMessageConfirm from "@/mobile/pages/receiveMessages/OtherUserReplyMessageConfirm.vue";
import MobileSafetyConfirmList from "@/mobile/pages/safetyConfirms/SafetyConfirmList.vue";
import MobileSendSafetyConfirmToOtherUserInput from "@/mobile/pages/safetyConfirms/SendSafetyConfirmToOtherUserInput.vue";
import MobileSendSafetyConfirmToOtherUserConfirm from "@/mobile/pages/safetyConfirms/SendSafetyConfirmToOtherUserConfirm.vue";
import MobileSendSafetyConfirmToOtherUserComplete from "@/mobile/pages/safetyConfirms/SendSafetyConfirmToOtherUserComplete.vue";
import MobileSendSafetyConfirmToOtherUserDetail from "@/mobile/pages/safetyConfirms/SendSafetyConfirmToOtherUserDetail.vue";
import MobileSafetyConfirmOtherUserTemplateInput from "@/mobile/pages/safetyConfirms/OtherUserTemplateInput.vue";
import MobileSafetyConfirmOtherUserTemplateConfirm from "@/mobile/pages/safetyConfirms/OtherUserTemplateConfirm.vue";
import MobileSafetyConfirmOtherUserTemplateComplete from "@/mobile/pages/safetyConfirms/OtherUserTemplateComplete.vue";
import MobileSafetyConfirmRegisterInput from "@/mobile/pages/safetyConfirms/SafetyConfirmRegisterInput.vue";
import MobileSafetyConfirmRegisterConfirm from "@/mobile/pages/safetyConfirms/SafetyConfirmRegisterConfirm.vue";
import MobileSafetyConfirmRegisterComplete from "@/mobile/pages/safetyConfirms/SafetyConfirmRegisterComplete.vue";

Vue.use(Router);

/**
 * vue router
 *
 * 各画面コンポーネントのルーティングを行う
 *
 * #Topic:
 * pathはブラウザ上のURLになる
 * nameはルーティング対象を一意に特定するための名前
 * ※nameとpathは同じ値を指定しているが、これはURLもnameも一意であるため
 *   また、コンポーネント間の移動をする際に$routerを使用して画面遷移する際にpath指定とname指定があり、
 *   pathとnameを別にしておくと煩雑という理由もある
 * componentは表示させる画面コンポーネント
 * metaはオプション情報を付与させることができる
 */
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      // ログイン
      path: Url.Root,
      name: Url.Root,
      component: Login,
      // #Topic:
      // isPublic:trueをつけていないものは、認証が必要になる
      // 認証チェックはrouter.beforeEach()で行っている
      meta: { isPublic: true }
    },
    {
      // メンテナンス
      path: Url.Maintenance,
      name: Url.Maintenance,
      component: Maintenance,
      meta: { isPublic: true }
    },
    {
      // システムエラー
      path: Url.SystemError,
      name: Url.SystemError,
      component: SystemError,
      meta: { isPublic: true }
    },
    {
      // ネットワークエラー
      path: Url.NetworkError,
      name: Url.NetworkError,
      component: NetworkError,
      meta: { isPublic: true }
    },
    {
      // サポート外ブラウザ
      path: Url.UnsupportedAgent,
      name: Url.UnsupportedAgent,
      component: UnsupportedAgent,
      meta: { isPublic: true }
    },
    /** pc pages */
    {
      path: PcUrl.Dashboard,
      component: BaseLayout,
      children: [
        {
          // ホーム
          path: PcUrl.HomeForFamilies,
          name: PcUrl.HomeForFamilies,
          component: HomeForFamiliesService
        },
        // 施設
        {
          path: PcUrl.Facility,
          name: PcUrl.Facility,
          component: Facility
        },
        {
          path: PcUrl.FacilityEdit,
          name: PcUrl.FacilityEdit,
          component: FacilityEdit
        },
        // 利用者
        {
          path: PcUrl.ResidentList,
          name: PcUrl.ResidentList,
          component: ResidentList
        },
        {
          path: PcUrl.ResidentRegister,
          name: PcUrl.ResidentRegister,
          component: ResidentRegister
        },
        {
          path: PcUrl.ResidentMultipleRegister,
          name: PcUrl.ResidentMultipleRegister,
          component: ResidentMultipleRegister
        },
        {
          path: PcUrl.ResidentRegisterForCooperationSystem,
          name: PcUrl.ResidentRegisterForCooperationSystem,
          component: GetResidentsForCooperationSystem
        },
        {
          path: PcUrl.ResidentFamilyEdit + "/:residentid" + "/:id",
          name: PcUrl.ResidentFamilyEdit,
          component: FamilyEdit
        },
        {
          path: PcUrl.ResidentDetail + "/:id",
          name: PcUrl.ResidentDetail,
          component: ResidentDetail
        },
        {
          // #Topic:
          // パラメータを渡す場合は、ブラウザの「更新」「戻る」「進む」に対応するためにURLにパラメータを含める
          path: PcUrl.ResidentEdit + "/:id" + "/:type",
          name: PcUrl.ResidentEdit,
          component: ResidentEdit
        },
        // 利用者グループ
        {
          path: PcUrl.ResidentGroupList,
          name: PcUrl.ResidentGroupList,
          component: ResidentGroupList
        },
        {
          path: PcUrl.ResidentGroupRegister,
          name: PcUrl.ResidentGroupRegister,
          component: ResidentGroupRegister
        },
        {
          path: PcUrl.ResidentGroupMemberEdit + "/:id",
          name: PcUrl.ResidentGroupMemberEdit,
          component: ResidentGroupMemberEdit
        },
        {
          path: PcUrl.ResidentGroupEdit + "/:id",
          name: PcUrl.ResidentGroupEdit,
          component: ResidentGroupEdit
        },
        // 施設関係者グループ
        {
          path: PcUrl.OtherUserGroupList,
          name: PcUrl.OtherUserGroupList,
          component: OtherUserGroupList
        },
        {
          path: PcUrl.OtherUserGroupEdit + "/:id",
          name: PcUrl.OtherUserGroupEdit,
          component: OtherUserGroupEdit
        },
        {
          path: PcUrl.OtherUserGroupRegister,
          name: PcUrl.OtherUserGroupRegister,
          component: OtherUserGroupRegister
        },
        {
          path: PcUrl.OtherUserGroupTypeList,
          name: PcUrl.OtherUserGroupTypeList,
          component: OtherUserGroupTypeList
        },
        {
          path: PcUrl.OtherUserGroupTypeEdit,
          name: PcUrl.OtherUserGroupTypeEdit,
          component: OtherUserGroupTypeEdit
        },
        {
          path: PcUrl.OtherUserGroupMemberRegister,
          name: PcUrl.OtherUserGroupMemberRegister,
          component: OtherUserGroupMemberRegister
        },
        {
          path: PcUrl.OtherUserGroupMemberEdit + "/:groupid" + "/:id",
          name: PcUrl.OtherUserGroupMemberEdit,
          component: OtherUserGroupMemberEdit
        },
        // 介護記録
        {
          path: PcUrl.CareimageList,
          name: PcUrl.CareimageList,
          component: CareimageList
        },
        {
          path: PcUrl.CareimageRegister + "/:id" + "/:date",
          name: PcUrl.CareimageRegister,
          component: CareimageRegister
        },
        {
          path: PcUrl.CareimageMultipleRegister + "/:date" + "/:start" + "/:end" + "/:existfamily" + "/:residentgroup" + "/:perpage" + "/:page",
          name: PcUrl.CareimageMultipleRegister,
          component: CareimageMultipleRegister
        },
        // 家族ユーザー
        {
          path: PcUrl.FamilyList,
          name: PcUrl.FamilyList,
          component: FamilyList
        },
        {
          path: PcUrl.FamilyRegister,
          name: PcUrl.FamilyRegister,
          component: FamilyRegister
        },
        {
          path: PcUrl.FamilyEdit + "/:residentid" + "/:id",
          name: PcUrl.FamilyEdit,
          component: FamilyEdit
        },
        // 面会予約一覧
        {
          path: PcUrl.ReservationList,
          name: PcUrl.ReservationList,
          component: ReservationList
        },
        {
          path: PcUrl.ReservationSettings,
          name: PcUrl.ReservationSettings,
          component: ReservationSettings
        },
        {
          path: PcUrl.ReservationSchedules,
          name: PcUrl.ReservationSchedules,
          component: ReservationSchedules
        },
        {
          path: PcUrl.ReservationScheduleTemplateList,
          name: PcUrl.ReservationScheduleTemplateList,
          component: ReservationScheduleTemplateList
        },
        {
          path: PcUrl.ReservationScheduleTemplateRegister,
          name: PcUrl.ReservationScheduleTemplateRegister,
          component: ReservationScheduleTemplateRegister
        },
        {
          path: PcUrl.ReservationScheduleTemplateEdit + "/:id",
          name: PcUrl.ReservationScheduleTemplateEdit,
          component: ReservationScheduleTemplateEdit
        },
        // 外出外泊届け
        {
          path: PcUrl.OutingList,
          name: PcUrl.OutingList,
          component: OutingList
        },
        {
          path: PcUrl.OutingDetail + "/:id",
          name: PcUrl.OutingDetail,
          component: OutingDetail
        },
        {
          path: PcUrl.OutingRegister,
          name: PcUrl.OutingRegister,
          component: OutingRegister
        },
        {
          path: PcUrl.OutingEdit + "/:id",
          name: PcUrl.OutingEdit,
          component: OutingEdit
        },
        {
          path: PcUrl.OutingSetting,
          name: PcUrl.OutingSetting,
          component: OutingSetting
        },
        // イベント
        {
          path: PcUrl.EventList,
          name: PcUrl.EventList,
          component: EventList
        },
        {
          path: PcUrl.EventRegister,
          name: PcUrl.EventRegister,
          component: EventRegister
        },
        {
          path: PcUrl.EventEdit + "/:id",
          name: PcUrl.EventEdit,
          component: EventEdit
        },
        {
          path: PcUrl.EventReplyRegister + "/:id",
          name: PcUrl.EventReplyRegister,
          component: EventReplyRegister
        },
        {
          path: PcUrl.EventReplyEdit + "/:id",
          name: PcUrl.EventReplyEdit,
          component: EventReplyEdit
        },
        // 写真
        {
          path: PcUrl.PictureList,
          name: PcUrl.PictureList,
          component: PictureList
        },
        // メッセージ
        {
          path: PcUrl.FamilyMessageList,
          name: PcUrl.FamilyMessageList,
          component: FamilyMessageList
        },
        // メッセージ送信
        {
          path: PcUrl.SendMessage,
          name: PcUrl.SendMessage,
          component: SendMessage
        },
        {
          path: PcUrl.SendMessageSettingEdit,
          name: PcUrl.SendMessageSettingEdit,
          component: SendMessageSettingEdit
        },
        // メッセージ送信テンプレート
        {
          path: PcUrl.SendMessageTemplateList,
          name: PcUrl.SendMessageTemplateList,
          component: SendMessageTemplateList
        },
        {
          path: PcUrl.SendMessageTemplateRegister,
          name: PcUrl.SendMessageTemplateRegister,
          component: SendMessageTemplateRegister
        },
        {
          path: PcUrl.SendMessageTemplateEdit + "/:id",
          name: PcUrl.SendMessageTemplateEdit,
          component: SendMessageTemplateEdit
        },
        // 文書送付
        {
          path: PcUrl.SendDocumentList,
          name: PcUrl.SendDocumentList,
          component: SendDocumentList
        },
        {
          path: PcUrl.SendDocumentRegister,
          name: PcUrl.SendDocumentRegister,
          component: SendDocumentRegister
        },
        {
          path: PcUrl.SendDocumentEdit + "/:id",
          name: PcUrl.SendDocumentEdit,
          component: SendDocumentEdit
        },
        {
          path: PcUrl.SendDocumentDetail + "/:id",
          name: PcUrl.SendDocumentDetail,
          component: SendDocumentDetail
        },
        {
          path: PcUrl.SendDocumentCategoryList,
          name: PcUrl.SendDocumentCategoryList,
          component: SendDocumentCategoryList
        },
        {
          path: PcUrl.SendDocumentCategoryEdit,
          name: PcUrl.SendDocumentCategoryEdit,
          component: SendDocumentCategoryEdit
        },
        {
          path: PcUrl.SendDocumentTemplateList,
          name: PcUrl.SendDocumentTemplateList,
          component: SendDocumentTemplateList
        },
        {
          path: PcUrl.SendDocumentTemplateRegister,
          name: PcUrl.SendDocumentTemplateRegister,
          component: SendDocumentTemplateRegister
        },
        {
          path: PcUrl.SendDocumentTemplateEdit + "/:id",
          name: PcUrl.SendDocumentTemplateEdit,
          component: SendDocumentTemplateEdit
        },
        // 宛先グループ一覧
        {
          path: PcUrl.SendMessageGroupList,
          name: PcUrl.SendMessageGroupList,
          component: SendMessageGroupList
        },
        {
          path: PcUrl.SendMessageGroupRegister,
          name: PcUrl.SendMessageGroupRegister,
          component: SendMessageGroupRegister
        },
        {
          path: PcUrl.SendMessageGroupMemberEdit + "/:id",
          name: PcUrl.SendMessageGroupMemberEdit,
          component: SendMessageGroupMemberEdit
        },
        {
          path: PcUrl.SendMessageGroupEdit + "/:id",
          name: PcUrl.SendMessageGroupEdit,
          component: SendMessageGroupEdit
        },
        // 受信メッセージ
        {
          path: PcUrl.ReceiveMessageList,
          name: PcUrl.ReceiveMessageList,
          component: ReceiveMessageList
        },
        {
          path: PcUrl.ReceiveMessageSetting,
          name: PcUrl.ReceiveMessageSetting,
          component: ReceiveMessageSetting
        },
        // お問い合わせ
        {
          path: PcUrl.SupportList,
          name: PcUrl.SupportList,
          component: SupportList
        },
        {
          path: PcUrl.SupportRegister + "/:type",
          name: PcUrl.SupportRegister,
          component: SupportRegister
        },
        {
          path: PcUrl.SupportFaqList,
          name: PcUrl.SupportFaqList,
          component: FaqList
        },
        {
          path: PcUrl.SupportManualList,
          name: PcUrl.SupportManualList,
          component: ManualList
        },
        // マニュアル
        {
          path: PcUrl.ManualList,
          name: PcUrl.ManualList,
          component: ManualList
        },
        // お知らせ
        {
          path: PcUrl.NotificationList,
          name: PcUrl.NotificationList,
          component: NotificationList
        },
        {
          path: PcUrl.NotificationDetail,
          name: PcUrl.NotificationDetail,
          component: NotificationDetail
        },
        // ユーザー情報変更
        {
          path: PcUrl.AccountEdit,
          name: PcUrl.AccountEdit,
          component: AccountEdit
        },
        // 家族・施設関係者のLINEbot操作の通知設定
        {
          path: PcUrl.NotificationSettingEdit,
          name: PcUrl.NotificationSettingEdit,
          component: NotificationSettingEdit
        },
        // 一般ユーザー管理
        {
          path: PcUrl.StandardAccountList,
          name: PcUrl.StandardAccountList,
          component: StandardAccountList
        },
        {
          path: PcUrl.StandardAccountRegister,
          name: PcUrl.StandardAccountRegister,
          component: StandardAccountRegister
        },
        {
          path: PcUrl.StandardAccountEdit,
          name: PcUrl.StandardAccountEdit,
          component: StandardAccountEdit
        },
        // HitomeQコネクトについて
        {
          path: PcUrl.About,
          name: PcUrl.About,
          component: About
        },
        // プラン確認・変更
        {
          path: PcUrl.Plan,
          name: PcUrl.Plan,
          component: Plan
        },
        // 使用機能の確認・変更(家族)
        {
          path: PcUrl.PermittedFunctionList,
          name: PcUrl.PermittedFunctionList,
          component: PermittedFunctionList
        },
        {
          path: PcUrl.PermittedFunctionEdit,
          name: PcUrl.PermittedFunctionEdit,
          component: PermittedFunctionEdit
        },
        // 家族の使用機能の確認・変更
        {
          path: PcUrl.FamilyPermittedFunctionList,
          name: PcUrl.FamilyPermittedFunctionList,
          component: FamilyPermittedFunctionList
        },
        {
          path: PcUrl.DefaultFamilyPermittedFunctionEdit,
          name: PcUrl.DefaultFamilyPermittedFunctionEdit,
          component: DefaultFamilyPermittedFunctionEdit
        },
        // 使用機能の確認・変更(施設関係者)
        {
          path: PcUrl.OtherUserPermittedFunctionList,
          name: PcUrl.OtherUserPermittedFunctionList,
          component: OtherUserPermittedFunctionList
        },
        {
          path: PcUrl.OtherUserPermittedFunctionEdit,
          name: PcUrl.OtherUserPermittedFunctionEdit,
          component: OtherUserPermittedFunctionEdit
        },
        // 解約
        {
          path: PcUrl.Terminate,
          name: PcUrl.Terminate,
          component: Terminate
        },
        // 活動履歴エクスポート
        {
          path: PcUrl.Report,
          name: PcUrl.Report,
          component: Report
        },
        // アンケート
        {
          path: PcUrl.QuestionnaireList,
          name: PcUrl.QuestionnaireList,
          component: QuestionnaireList
        },
        {
          path: PcUrl.QuestionnaireRegister, // コピー登録の場合queryでidを渡す（this.$router.push(PcUrl.QuestionnaireRegister + `?id=${item.id}`);）
          name: PcUrl.QuestionnaireRegister,
          component: QuestionnaireRegister
        },
        {
          path: PcUrl.QuestionnaireEdit + "/:id",
          name: PcUrl.QuestionnaireEdit,
          component: QuestionnaireEdit
        },
        {
          path: PcUrl.QuestionnaireDetail + "/:id",
          name: PcUrl.QuestionnaireDetail,
          component: QuestionnaireDetail
        },
        // 安否確認
        {
          path: PcUrl.SafetyConfirmList,
          name: PcUrl.SafetyConfirmList,
          component: SafetyConfirmList
        },
        {
          path: PcUrl.SafetyConfirmRegister,
          name: PcUrl.SafetyConfirmRegister,
          component: SafetyConfirmRegister
        },
        {
          path: PcUrl.FamilySafetyConfirmTemplateEdit,
          name: PcUrl.FamilySafetyConfirmTemplateEdit,
          component: FamilyTemplateEdit
        },
        {
          path: PcUrl.FamilySafetyConfirmDetail + "/:id",
          name: PcUrl.FamilySafetyConfirmDetail,
          component: FamilySafetyConfirmDetail
        },
        {
          path: PcUrl.OtherUserSafetyConfirmTemplateEdit,
          name: PcUrl.OtherUserSafetyConfirmTemplateEdit,
          component: OtherUserTemplateEdit
        },
        {
          path: PcUrl.SendOtherUserSafetyConfirm + "/:id",
          name: PcUrl.SendOtherUserSafetyConfirm,
          component: SendOtherUserSafetyConfirm
        },
        {
          path: PcUrl.OtherUserSafetyConfirmDetail + "/:id",
          name: PcUrl.OtherUserSafetyConfirmDetail,
          component: OtherUserSafetyConfirmDetail
        },
        {
          path: PcUrl.OtherUserSafetyConfirmAnswers + "/:id",
          name: PcUrl.OtherUserSafetyConfirmAnswers,
          component: OtherUserSafetyConfirmAnswers
        },
        // 部屋
        {
          path: PcUrl.RoomList,
          name: PcUrl.RoomList,
          component: RoomList
        },
        {
          path: PcUrl.RoomRegister,
          name: PcUrl.RoomRegister,
          component: RoomRegister
        },
        {
          path: PcUrl.RoomEdit + "/:id",
          name: PcUrl.RoomEdit,
          component: RoomEdit
        },
        {
          path: PcUrl.RoomMultipleRegister,
          name: PcUrl.RoomMultipleRegister,
          component: RoomMultipleRegister
        },
        // 空床
        {
          path: PcUrl.RoomScheduleList,
          name: PcUrl.RoomScheduleList,
          component: RoomScheduleList
        },
        {
          path: PcUrl.RoomScheduleResidentEdit + "/:id" + "/:type",
          name: PcUrl.RoomScheduleResidentEdit,
          component: ResidentEdit
        },
        {
          path: PcUrl.RoomScheduleSetting + "/:type",
          name: PcUrl.RoomScheduleSetting,
          component: RoomScheduleSetting
        },
        {
          path: PcUrl.CooperationSystemList,
          name: PcUrl.CooperationSystemList,
          component: CooperationSystemList
        },
        /** 入居者募集管理 */
        {
          // ホーム
          path: PcUrl.HomeForWaiters,
          name: PcUrl.HomeForWaiters,
          component: HomeForWaitersService
        },
        // 待機者
        {
          path: PcUrl.WaiterList,
          name: PcUrl.WaiterList,
          component: WaiterList
        },
        {
          path: PcUrl.WaiterListDownload,
          name: PcUrl.WaiterListDownload,
          component: WaiterListDownload
        },
        {
          path: PcUrl.WaiterSetting,
          name: PcUrl.WaiterSetting,
          component: WaiterSetting
        },
        {
          path: PcUrl.WaiterRegister,
          name: PcUrl.WaiterRegister,
          component: WaiterRegister
        },
        {
          path: PcUrl.WaiterDetail + "/:facilityid" + "/:residentid" + "/:idinsystem",
          name: PcUrl.WaiterDetail,
          component: WaiterDetail
        },
        {
          path: PcUrl.WaiterChangeRequest + "/:facilityid" + "/:residentid" + "/:idinsystem",
          name: PcUrl.WaiterChangeRequest,
          component: WaiterChangeRequest
        },
        {
          path: PcUrl.WaiterEdit + "/:facilityid" + "/:residentid" + "/:idinsystem" + "/:backtype",
          name: PcUrl.WaiterEdit,
          component: WaiterEdit
        },
        {
          path: PcUrl.WaiterProgressHistoryRegister + "/:facilityid" + "/:residentid" + "/:idinsystem",
          name: PcUrl.WaiterProgressHistoryRegister,
          component: WaiterProgressHistoryRegister
        },
        {
          path: PcUrl.WaiterProgressHistoryEdit + "/:facilityid" + "/:residentid" + "/:idinsystem" + "/:historyid",
          name: PcUrl.WaiterProgressHistoryEdit,
          component: WaiterProgressHistoryEdit
        },
        {
          path: PcUrl.WaiterFamilyRegister + "/:facilityid" + "/:residentid" + "/:idinsystem",
          name: PcUrl.WaiterFamilyRegister,
          component: WaiterFamilyRegister
        },
        {
          path: PcUrl.WaiterFamilyEdit + "/:facilityid" + "/:residentid" + "/:idinsystem" + "/:familyid",
          name: PcUrl.WaiterFamilyEdit,
          component: WaiterFamilyEdit
        },
        // 受信メッセージ
        {
          path: PcUrl.WaiterReceiveMessageList,
          name: PcUrl.WaiterReceiveMessageList,
          component: WaiterReceiveMessageList
        },
        {
          path: PcUrl.WaiterReceiveMessageSetting,
          name: PcUrl.WaiterReceiveMessageSetting,
          component: WaiterReceiveMessageSetting
        },
        // フォロワー一覧
        {
          path: PcUrl.FollowerList,
          name: PcUrl.FollowerList,
          component: FollowerList
        },
        // 施設見学予約
        {
          path: PcUrl.InspectionReservationList,
          name: PcUrl.InspectionReservationList,
          component: InspectionReservationList
        },
        {
          path: PcUrl.InspectionReservationRegister,
          name: PcUrl.InspectionReservationRegister,
          component: InspectionReservationRegister
        },
        {
          path: PcUrl.InspectionReservationEdit + "/:datetime",
          name: PcUrl.InspectionReservationEdit,
          component: InspectionReservationEdit
        },
        // 入所募集問い合わせ
        {
          path: PcUrl.RecruitmentContactList,
          name: PcUrl.RecruitmentContactList,
          component: RecruitmentContactList
        },
        {
          path: PcUrl.RecruitmentContactRegister,
          name: PcUrl.RecruitmentContactRegister,
          component: RecruitmentContactRegister
        },
        {
          path: PcUrl.RecruitmentContactEdit + "/:datetime",
          name: PcUrl.RecruitmentContactEdit,
          component: RecruitmentContactEdit
        },
        // 待機者メッセージ
        {
          path: PcUrl.WaiterSendMessage,
          name: PcUrl.WaiterSendMessage,
          component: WaiterSendMessage
        },
        {
          path: PcUrl.WaiterSendMessageSetting,
          name: PcUrl.WaiterSendMessageSetting,
          component: WaiterSettingEdit
        },
        {
          path: PcUrl.WaiterSendMessageTemplateList,
          name: PcUrl.WaiterSendMessageTemplateList,
          component: WaiterTemplateList
        },
        {
          path: PcUrl.WaiterSendMessageTemplateRegister,
          name: PcUrl.WaiterSendMessageTemplateRegister,
          component: WaiterTemplateRegister
        },
        {
          path: PcUrl.WaiterSendMessageTemplateEdit + "/:id",
          name: PcUrl.WaiterSendMessageTemplateEdit,
          component: WaiterTemplateEdit
        },
        /** 他事業所連携 */
        {
          // ホーム
          path: PcUrl.HomeForOtherOffice,
          name: PcUrl.HomeForOtherOffice,
          component: HomeForOtherOfficeService
        },
        {
          // ホーム
          path: PcUrl.OtherOfficeConnectionEdit,
          name: PcUrl.OtherOfficeConnectionEdit,
          component: OtherOfficeConnectionEdit
        },
        {
          // メッセージ
          path: PcUrl.OtherOfficeMessages,
          name: PcUrl.OtherOfficeMessages,
          component: OtherOfficeSendMessage
        },
        {
          // オンライン会議
          path: PcUrl.OtherOfficeOnlineMeetings,
          name: PcUrl.OtherOfficeOnlineMeetings,
          component: OtherOfficeOnlineMeetings
        },
        {
          // オンライン会議登録
          path: PcUrl.OtherOfficeOnlineMeetingRegister,
          name: PcUrl.OtherOfficeOnlineMeetingRegister,
          component: OtherOfficeOnlineMeetingRegister
        },
        {
          // オンライン会議詳細
          path: PcUrl.OtherOfficeOnlineMeetingDetail + "/:targetFacilityId" + "/:id",
          name: PcUrl.OtherOfficeOnlineMeetingDetail,
          component: OtherOfficeOnlineMeetingDetail
        },
        {
          // オンライン会議修正
          path: PcUrl.OtherOfficeOnlineMeetingEdit + "/:targetFacilityId" + "/:id",
          name: PcUrl.OtherOfficeOnlineMeetingEdit,
          component: OtherOfficeOnlineMeetingEdit
        },
        {
          // 空床情報
          path: PcUrl.OtherOfficeRoomSchedules,
          name: PcUrl.OtherOfficeRoomSchedules,
          component: OtherOfficeRoomsScheduleList
        }
      ]
    },
    /** mobile pages */
    {
      path: MobileUrl.Dashboard,
      component: MobileBase,
      children: [
        {
          // ホーム
          path: MobileUrl.Home,
          name: MobileUrl.Home,
          component: MobileHome
        },
        {
          // 面会予約一覧
          path: MobileUrl.ReservationList,
          name: MobileUrl.ReservationList,
          component: MobileReservationList
        },
        {
          // 面会予約詳細
          path: MobileUrl.ReservationDetail + "/:id",
          name: MobileUrl.ReservationDetail,
          component: MobileReservationDetail
        },
        {
          // 外出外泊届け
          path: MobileUrl.OutingList,
          name: MobileUrl.OutingList,
          component: MobileOutingList
        },
        {
          // 外出外泊届け詳細
          path: MobileUrl.OutingDetail + "/:id",
          name: MobileUrl.OutingDetail,
          component: MobileOutingDetail
        },
        {
          // 外出外泊届け編集
          path: MobileUrl.OutingEdit + "/:id",
          name: MobileUrl.OutingEdit,
          component: MobileOutingEdit
        },
        {
          // メッセージ送信入力
          path: MobileUrl.MessageRegisterInput,
          name: MobileUrl.MessageRegisterInput,
          component: MobileMessageRegisterInput
        },
        {
          // メッセージ送信入力確認
          path: MobileUrl.MessageRegisterConfirm,
          name: MobileUrl.MessageRegisterConfirm,
          component: MobileMessageRegisterConfirm
        },
        {
          // メッセージ送信完了
          path: MobileUrl.MessageRegisterComplete,
          name: MobileUrl.MessageRegisterComplete,
          component: MobileMessageRegisterComplete
        },
        {
          // 新着メッセージ
          path: MobileUrl.NewArrivalMessagesList,
          name: MobileUrl.NewArrivalMessagesList,
          component: MobileNewArrivalMessagesList
        },
        {
          // メッセージ履歴(家族)
          path: MobileUrl.FamilyMessageList,
          name: MobileUrl.FamilyMessageList,
          component: MobileFamilyMessageList
        },
        {
          // メッセージ履歴詳細(家族)
          path: MobileUrl.FamilyMessageHistoryDetail + "/:type",
          name: MobileUrl.FamilyMessageHistoryDetail,
          component: MobileFamilyMessageHistoryDetail
        },
        {
          // メッセージ履歴返信詳細(家族)
          path: MobileUrl.FamilyMessageReplyDetail + "/:type",
          name: MobileUrl.FamilyMessageReplyDetail,
          component: MobileFamilyMessageReplyDetail
        },
        {
          // メッセージ履歴(施設関係者)
          path: MobileUrl.OtherUserMessageList,
          name: MobileUrl.OtherUserMessageList,
          component: MobileOtherUserMessageList
        },
        {
          // メッセージ履歴詳細(施設関係者)
          path: MobileUrl.OtherUserMessageHistoryDetail + "/:type",
          name: MobileUrl.OtherUserMessageHistoryDetail,
          component: MobileOtherUserMessageHistoryDetail
        },
        {
          // メッセージ履歴返信詳細(家族)
          path: MobileUrl.OtherUserMessageeReplyHistoryDetail + "/:type",
          name: MobileUrl.OtherUserMessageeReplyHistoryDetail,
          component: MobileOtherUserMessageReplyDetail
        },
        {
          // 受信メッセージ(家族)
          path: MobileUrl.FamilyReceiveMessageList,
          name: MobileUrl.FamilyReceiveMessageList,
          component: MobileFamilyReceiveMessageList
        },
        {
          // 受信メッセージ詳細(家族)
          path: MobileUrl.FamilyReceiveMessageDetail + "/:type",
          name: MobileUrl.FamilyReceiveMessageDetail,
          component: MobileFamilyReceiveMessageDetail
        },
        {
          // 受信メッセージ返信(家族)
          path: MobileUrl.FamilyReplyReceiveMessageConfirm + "/:type",
          name: MobileUrl.FamilyReplyReceiveMessageConfirm,
          component: MobileFamilyReplyMessageConfirm
        },
        {
          // 受信メッセージ(施設関係者)
          path: MobileUrl.OtherUserReceiveMessageList,
          name: MobileUrl.OtherUserReceiveMessageList,
          component: MobileOtherUserReceiveMessageList
        },
        {
          // 受信メッセージ詳細(施設関係者)
          path: MobileUrl.OtherUserReceiveMessageDetail + "/:type",
          name: MobileUrl.OtherUserReceiveMessageDetail,
          component: MobileOtherUserReceiveMessageDetail
        },
        {
          // 受信メッセージ返信(施設関係者)
          path: MobileUrl.OtherUserReplyReceiveMessageConfirm + "/:type",
          name: MobileUrl.OtherUserReplyReceiveMessageConfirm,
          component: MobileOtherUserReplyMessageConfirm
        },
        // 安否確認
        {
          // 一覧
          path: MobileUrl.SafetyConfirmList,
          name: MobileUrl.SafetyConfirmList,
          component: MobileSafetyConfirmList
        },
        {
          // 安否確認入力依頼のメッセージ送信 入力
          path: MobileUrl.SendSafetyConfirmToOtherUserInput + "/:id",
          name: MobileUrl.SendSafetyConfirmToOtherUserInput,
          component: MobileSendSafetyConfirmToOtherUserInput
        },
        {
          // 安否確認入力依頼のメッセージ送信 確認
          path: MobileUrl.SendSafetyConfirmToOtherUserConfirm,
          name: MobileUrl.SendSafetyConfirmToOtherUserConfirm,
          component: MobileSendSafetyConfirmToOtherUserConfirm
        },
        {
          // 安否確認入力依頼のメッセージ送信 完了
          path: MobileUrl.SendSafetyConfirmToOtherUserComplete,
          name: MobileUrl.SendSafetyConfirmToOtherUserComplete,
          component: MobileSendSafetyConfirmToOtherUserComplete
        },
        {
          // 安否確認入力依頼のメッセージ送信 詳細
          path: MobileUrl.SendSafetyConfirmToOtherUserDetail + "/:id",
          name: MobileUrl.SendSafetyConfirmToOtherUserDetail,
          component: MobileSendSafetyConfirmToOtherUserDetail
        },
        {
          // 事前設定(施設関係者) 入力
          path: MobileUrl.SafetyConfirmOtherUserTempleteInput,
          name: MobileUrl.SafetyConfirmOtherUserTempleteInput,
          component: MobileSafetyConfirmOtherUserTemplateInput
        },
        {
          // 事前設定(施設関係者) 確認
          path: MobileUrl.SafetyConfirmOtherUserTempleteConfirm,
          name: MobileUrl.SafetyConfirmOtherUserTempleteConfirm,
          component: MobileSafetyConfirmOtherUserTemplateConfirm
        },
        {
          // 事前設定(施設関係者) 完了
          path: MobileUrl.SafetyConfirmOtherUserTempleteComplete,
          name: MobileUrl.SafetyConfirmOtherUserTempleteComplete,
          component: MobileSafetyConfirmOtherUserTemplateComplete
        },
        {
          // 安否確認登録 入力
          path: MobileUrl.SafetyConfirmRegisterInput,
          name: MobileUrl.SafetyConfirmRegisterInput,
          component: MobileSafetyConfirmRegisterInput
        },
        {
          // 安否確認登録 確認
          path: MobileUrl.SafetyConfirmRegisterConfirm,
          name: MobileUrl.SafetyConfirmRegisterConfirm,
          component: MobileSafetyConfirmRegisterConfirm
        },
        {
          // 安否確認登録 完了
          path: MobileUrl.SafetyConfirmRegisterComplete,
          name: MobileUrl.SafetyConfirmRegisterComplete,
          component: MobileSafetyConfirmRegisterComplete
        }
      ]
    },
    /**
     * 404 NotFound
     * データが無い場合のNotFoundと存在しないURLによるNotFoundの2種類
     */
    {
      path: Url.NotFound,
      name: Url.NotFound,
      component: NotFound
    },
    {
      path: "*",
      component: NotFound
    }
  ]
});
